"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var RatingStars_1 = tslib_1.__importDefault(require("../../../RatingStars"));

var styles = tslib_1.__importStar(require("./index.style"));

var Statistics_1 = tslib_1.__importDefault(require("../../common/Statistics"));

var DetailScore_1 = tslib_1.__importDefault(require("../../common/DetailScore"));

function GradeBlock(_ref) {
  var className = _ref.className,
      averageScore = _ref.averageScore,
      averageScoreDetails = _ref.averageScoreDetails,
      reviewScoreCounts = _ref.reviewScoreCounts;
  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: styles.wrapper
  }, {
    children: [jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.totalGrade
    }, {
      children: [jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.averageScoreWrapper
      }, {
        children: [jsx_runtime_1.jsx("span", Object.assign({
          css: styles.averageScore
        }, {
          children: averageScore.toFixed(1)
        }), void 0), jsx_runtime_1.jsx(RatingStars_1.default, {
          css: styles.star,
          ratingValue: averageScore
        }, void 0)]
      }), void 0), jsx_runtime_1.jsx(Statistics_1.default, {
        reviewScoreCounts: reviewScoreCounts
      }, void 0)]
    }), void 0), jsx_runtime_1.jsx("div", {
      css: styles.divider
    }, void 0), jsx_runtime_1.jsx("div", Object.assign({
      css: styles.detailWrapper
    }, {
      children: averageScoreDetails.map(function (scoreDetail, index) {
        return jsx_runtime_1.jsx(DetailScore_1.default, {
          scoreDetail: scoreDetail
        }, "".concat(scoreDetail.key));
      })
    }), void 0)]
  }), void 0);
}

exports.default = react_1.memo(GradeBlock);